import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockArticles, LazyBlockArticlesRelated, LazyBlockBackedByData, LazyBlockBricks, LazyBlockCards, LazyBlockCompliance, LazyBlockCtas, LazyBlockFaqs, LazyBlockFeatures, LazyBlockHighlights, LazyBlockHowItWorks, LazyBlockLinkedin, LazyBlockLogos, LazyBlockResources, LazyBlockShowcase, LazyBlockSolutions, LazyBlockStats, LazyBlockTeam, LazyBlockTestimonial, LazyBlockText, LazyBlockTrust, LazyBlockUseCases, LazyBlockUsps, LazyBlockVideo, LazyComparisonEQS, LazyContainer, LazyCountrySelect, LazyEIModal, LazyElementBlogCard, LazyElementBlogCardList, LazyElementBlogCategories, LazyElementBookCall, LazyElementBookDemoCta, LazyElementBreadcrumbs, LazyElementBrick, LazyElementButton, LazyElementComparisonTable, LazyElementContent, LazyElementFeedback, LazyElementHero, LazyElementHeroBlog, LazyElementHeroHome, LazyElementHeroInfo, LazyElementHeroPolicy, LazyElementHeroStats, LazyElementHeroB, LazyElementHighlight, LazyElementImage, LazyElementLeaveDetails, LazyElementModal, LazyElementProduct, LazyElementQuote, LazyElementSearchBar, LazyElementSkipLink, LazyElementTableOfContents, LazyElementTag, LazyElementUspImage, LazyElementUspList, LazyElementVideo, LazyElementWebinarCard, LazyFadeIn, LazyFooter, LazyGetQuoteButton, LazyHeader, LazyImageResponsive, LazyImportSvg, LazyLogo, LazyLogoFooter, LazyPolicySubprocessorsTable, LazySection, LazyToolkitPsychosocialQuiz, LazyToolkitPsychosocialResults, LazyToolkitPsychosocialToolkit, LazyVideoPlayer, LazySvgoDuotoneArrowDownToLine, LazySvgoDuotoneBuildingColumns, LazySvgoDuotoneBuildingShield, LazySvgoDuotoneBullhorn, LazySvgoDuotoneChartLineUpDown, LazySvgoDuotoneCircleCheck, LazySvgoDuotoneCity, LazySvgoDuotoneClipboardListCheck, LazySvgoDuotoneClipboardQuestion, LazySvgoDuotoneCodeCompare, LazySvgoDuotoneFaceExhaling, LazySvgoDuotoneFaceSmilePlus, LazySvgoDuotoneFileCertificate, LazySvgoDuotoneFileExport, LazySvgoDuotoneGraduationCap, LazySvgoDuotoneHandHoldingHand, LazySvgoDuotoneHandHoldingHeart, LazySvgoDuotoneHeadSideBrain, LazySvgoDuotoneHexagonCheck, LazySvgoDuotoneHouseChimneyMedical, LazySvgoDuotoneInboxIn, LazySvgoDuotoneLanguage, LazySvgoDuotoneListCheck, LazySvgoDuotoneMemoCircleInfo, LazySvgoDuotoneMessageExclamation, LazySvgoDuotoneMobileButton, LazySvgoDuotoneObjectIntersect, LazySvgoDuotonePenField, LazySvgoDuotonePeopleArrows, LazySvgoDuotonePeopleGroup, LazySvgoDuotonePeoplePantsSimple, LazySvgoDuotonePeoplePants, LazySvgoDuotonePeopleRoof, LazySvgoDuotonePersonChalkboard, LazySvgoDuotonePersonCircleExclamation, LazySvgoDuotonePersonFallingBurst, LazySvgoDuotonePersonSimple, LazySvgoDuotonePuzzle, LazySvgoDuotoneSchool, LazySvgoDuotoneShieldCheck, LazySvgoDuotoneShieldQuartered, LazySvgoDuotoneUserHelmetSafety, LazySvgoDuotoneUserPlus, LazySvgoDuotoneUsers, LazySvgoDuotoneWheelchair, LazySvgoDuotoneWhistle, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["BlockArticles", LazyBlockArticles],
["BlockArticlesRelated", LazyBlockArticlesRelated],
["BlockBackedByData", LazyBlockBackedByData],
["BlockBricks", LazyBlockBricks],
["BlockCards", LazyBlockCards],
["BlockCompliance", LazyBlockCompliance],
["BlockCtas", LazyBlockCtas],
["BlockFaqs", LazyBlockFaqs],
["BlockFeatures", LazyBlockFeatures],
["BlockHighlights", LazyBlockHighlights],
["BlockHowItWorks", LazyBlockHowItWorks],
["BlockLinkedin", LazyBlockLinkedin],
["BlockLogos", LazyBlockLogos],
["BlockResources", LazyBlockResources],
["BlockShowcase", LazyBlockShowcase],
["BlockSolutions", LazyBlockSolutions],
["BlockStats", LazyBlockStats],
["BlockTeam", LazyBlockTeam],
["BlockTestimonial", LazyBlockTestimonial],
["BlockText", LazyBlockText],
["BlockTrust", LazyBlockTrust],
["BlockUseCases", LazyBlockUseCases],
["BlockUsps", LazyBlockUsps],
["BlockVideo", LazyBlockVideo],
["ComparisonEQS", LazyComparisonEQS],
["Container", LazyContainer],
["CountrySelect", LazyCountrySelect],
["EIModal", LazyEIModal],
["ElementBlogCard", LazyElementBlogCard],
["ElementBlogCardList", LazyElementBlogCardList],
["ElementBlogCategories", LazyElementBlogCategories],
["ElementBookCall", LazyElementBookCall],
["ElementBookDemoCta", LazyElementBookDemoCta],
["ElementBreadcrumbs", LazyElementBreadcrumbs],
["ElementBrick", LazyElementBrick],
["ElementButton", LazyElementButton],
["ElementComparisonTable", LazyElementComparisonTable],
["ElementContent", LazyElementContent],
["ElementFeedback", LazyElementFeedback],
["ElementHero", LazyElementHero],
["ElementHeroBlog", LazyElementHeroBlog],
["ElementHeroHome", LazyElementHeroHome],
["ElementHeroInfo", LazyElementHeroInfo],
["ElementHeroPolicy", LazyElementHeroPolicy],
["ElementHeroStats", LazyElementHeroStats],
["ElementHeroB", LazyElementHeroB],
["ElementHighlight", LazyElementHighlight],
["ElementImage", LazyElementImage],
["ElementLeaveDetails", LazyElementLeaveDetails],
["ElementModal", LazyElementModal],
["ElementProduct", LazyElementProduct],
["ElementQuote", LazyElementQuote],
["ElementSearchBar", LazyElementSearchBar],
["ElementSkipLink", LazyElementSkipLink],
["ElementTableOfContents", LazyElementTableOfContents],
["ElementTag", LazyElementTag],
["ElementUspImage", LazyElementUspImage],
["ElementUspList", LazyElementUspList],
["ElementVideo", LazyElementVideo],
["ElementWebinarCard", LazyElementWebinarCard],
["FadeIn", LazyFadeIn],
["Footer", LazyFooter],
["GetQuoteButton", LazyGetQuoteButton],
["Header", LazyHeader],
["ImageResponsive", LazyImageResponsive],
["ImportSvg", LazyImportSvg],
["Logo", LazyLogo],
["LogoFooter", LazyLogoFooter],
["PolicySubprocessorsTable", LazyPolicySubprocessorsTable],
["Section", LazySection],
["ToolkitPsychosocialQuiz", LazyToolkitPsychosocialQuiz],
["ToolkitPsychosocialResults", LazyToolkitPsychosocialResults],
["ToolkitPsychosocialToolkit", LazyToolkitPsychosocialToolkit],
["VideoPlayer", LazyVideoPlayer],
["SvgoDuotoneArrowDownToLine", LazySvgoDuotoneArrowDownToLine],
["SvgoDuotoneBuildingColumns", LazySvgoDuotoneBuildingColumns],
["SvgoDuotoneBuildingShield", LazySvgoDuotoneBuildingShield],
["SvgoDuotoneBullhorn", LazySvgoDuotoneBullhorn],
["SvgoDuotoneChartLineUpDown", LazySvgoDuotoneChartLineUpDown],
["SvgoDuotoneCircleCheck", LazySvgoDuotoneCircleCheck],
["SvgoDuotoneCity", LazySvgoDuotoneCity],
["SvgoDuotoneClipboardListCheck", LazySvgoDuotoneClipboardListCheck],
["SvgoDuotoneClipboardQuestion", LazySvgoDuotoneClipboardQuestion],
["SvgoDuotoneCodeCompare", LazySvgoDuotoneCodeCompare],
["SvgoDuotoneFaceExhaling", LazySvgoDuotoneFaceExhaling],
["SvgoDuotoneFaceSmilePlus", LazySvgoDuotoneFaceSmilePlus],
["SvgoDuotoneFileCertificate", LazySvgoDuotoneFileCertificate],
["SvgoDuotoneFileExport", LazySvgoDuotoneFileExport],
["SvgoDuotoneGraduationCap", LazySvgoDuotoneGraduationCap],
["SvgoDuotoneHandHoldingHand", LazySvgoDuotoneHandHoldingHand],
["SvgoDuotoneHandHoldingHeart", LazySvgoDuotoneHandHoldingHeart],
["SvgoDuotoneHeadSideBrain", LazySvgoDuotoneHeadSideBrain],
["SvgoDuotoneHexagonCheck", LazySvgoDuotoneHexagonCheck],
["SvgoDuotoneHouseChimneyMedical", LazySvgoDuotoneHouseChimneyMedical],
["SvgoDuotoneInboxIn", LazySvgoDuotoneInboxIn],
["SvgoDuotoneLanguage", LazySvgoDuotoneLanguage],
["SvgoDuotoneListCheck", LazySvgoDuotoneListCheck],
["SvgoDuotoneMemoCircleInfo", LazySvgoDuotoneMemoCircleInfo],
["SvgoDuotoneMessageExclamation", LazySvgoDuotoneMessageExclamation],
["SvgoDuotoneMobileButton", LazySvgoDuotoneMobileButton],
["SvgoDuotoneObjectIntersect", LazySvgoDuotoneObjectIntersect],
["SvgoDuotonePenField", LazySvgoDuotonePenField],
["SvgoDuotonePeopleArrows", LazySvgoDuotonePeopleArrows],
["SvgoDuotonePeopleGroup", LazySvgoDuotonePeopleGroup],
["SvgoDuotonePeoplePantsSimple", LazySvgoDuotonePeoplePantsSimple],
["SvgoDuotonePeoplePants", LazySvgoDuotonePeoplePants],
["SvgoDuotonePeopleRoof", LazySvgoDuotonePeopleRoof],
["SvgoDuotonePersonChalkboard", LazySvgoDuotonePersonChalkboard],
["SvgoDuotonePersonCircleExclamation", LazySvgoDuotonePersonCircleExclamation],
["SvgoDuotonePersonFallingBurst", LazySvgoDuotonePersonFallingBurst],
["SvgoDuotonePersonSimple", LazySvgoDuotonePersonSimple],
["SvgoDuotonePuzzle", LazySvgoDuotonePuzzle],
["SvgoDuotoneSchool", LazySvgoDuotoneSchool],
["SvgoDuotoneShieldCheck", LazySvgoDuotoneShieldCheck],
["SvgoDuotoneShieldQuartered", LazySvgoDuotoneShieldQuartered],
["SvgoDuotoneUserHelmetSafety", LazySvgoDuotoneUserHelmetSafety],
["SvgoDuotoneUserPlus", LazySvgoDuotoneUserPlus],
["SvgoDuotoneUsers", LazySvgoDuotoneUsers],
["SvgoDuotoneWheelchair", LazySvgoDuotoneWheelchair],
["SvgoDuotoneWhistle", LazySvgoDuotoneWhistle],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
